import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useRequest from "../../../utils/hook/requestHook";
import { post } from "../../../api";
import { GET_BILL_BY_WEBUSER } from "../../../api/apiRoutes";
import { Box } from "@material-ui/core";
import TranslatedMaterialTable from "../../../shared/TranslatedMaterialTable";
import { format } from "date-fns";
import { BillHeaders } from "../../../models/BillHeaders";

const columns = [
  {
    title: "Numer dokumentu",
    field: "documentNumber",
  },
  { title: "Cena", field: "total" },
  { title: "Data", field: "billDate", render: (row: BillHeaders) => `${format(row.billDate, "yyyy-MM-dd, HH:mm:ss")}` },
  {
    title: "Status",
    field: "status",
    render: (row: BillHeaders) => `${getStatusName(row.status)}`,
  },
];

const getStatusName = (value: string | undefined) => {
  switch (value) {
    case "P":
      return "Opłacony";
    case "U":
      return "Nieopłacony";
    case "A":
      return "Anulowany";
    case "C":
      return "Opłacony";
    default:
      return "Nieznany status";
  }
};

const DocumentsTableTab: React.FC = () => {
  const webUser = useSelector((state: State) => state.auth.webUser);
  const [data, loading] = useRequest<BillHeaders[]>(
    async () => await post(GET_BILL_BY_WEBUSER, { objectDb: webUser.objectDb, objectId: webUser.objectId })
  );
  return (
    <Box my={3} style={{ width: "100%" }}>
      <TranslatedMaterialTable
        onRowClick={() => {}}
        title={``}
        isLoading={loading}
        columns={columns}
        data={data ? data : []}
      />
    </Box>
  );
};

export default DocumentsTableTab;
